import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'
import { CANCELLATION_REASONS } from '@/routes/billing/danger-zone/delete-company-sheet/reasons'
import type { DeleteCompanyFormValues } from '@/routes/billing/danger-zone/delete-company-sheet/reasons'
import type { UseFormReturn } from 'react-hook-form'

type Props = {
  form: UseFormReturn<DeleteCompanyFormValues>
}

export const ReasonStep = ({ form }: Props) => {
  const selectedReason = form.watch('reason')
  const isOtherSelected = selectedReason === 'Other'

  return (
    <>
      <FormField
        control={form.control}
        name="reason"
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormLabel>Why are you leaving?</FormLabel>
            <FormControl>
              <RadioGroup
                className="grid gap-2"
                onValueChange={onChange}
                value={value}
              >
                {CANCELLATION_REASONS.map((reason) => (
                  <Label
                    key={reason}
                    className={cn(
                      'has-[[data-state=checked]]:border-ring has-[[data-state=checked]]:bg-input/20',
                      'flex items-center gap-3 rounded-lg border px-3 py-3 cursor-pointer'
                    )}
                  >
                    <RadioGroupItem
                      value={reason}
                      id={reason}
                      className="data-[state=checked]:border-primary"
                    />
                    {reason}
                  </Label>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {isOtherSelected ? (
        <FormField
          control={form.control}
          name="reasonDetails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tell us more</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="What made you decide to leave?"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
      <FormField
        control={form.control}
        name="feedback"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Anything else you would like to share? (optional)
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="Your feedback helps us improve Sevalla"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  )
}
